import { render, staticRenderFns } from "./claim.vue?vue&type=template&id=fb92af50&scoped=true&"
import script from "./claim.vue?vue&type=script&lang=js&"
export * from "./claim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb92af50",
  null
  
)

export default component.exports